// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"0bed7260","99":"52d21bd0","284":"17023557","352":"8d2a6466","407":"4c8df2bf","456":"ef7ab213","497":"34047167","639":"1cf79b53","744":"1ead8a78","859":"07390845","878":"f95c59c1","932":"fb47f17b"}[chunkId] + ".chunk.js";
};